export default __webpack_public_path__ + "static/media/MakeGoldfishTank_07.70da69bb.png";